import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { isNullOrUndefined } from '@app/util/util';

import { loaderColors } from '@ux/entities/loader-colors';
import { BtnLoaderSize } from '@ux/components/btn-loader/entities/btn-loader-styles';

const agentTravelImage = 'ilustra-agente-travel-upsell.png';
const FARE_PATTERNS = /(tarifa)/gi;

@Component({
  selector: 'app-travel-segment-upsell',
  templateUrl: './travel-segment-upsell.component.html',
  styleUrls: ['./travel-segment-upsell.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TravelSegmentUpsellComponent {

  @Input() baggage: boolean = false;
  @Input() fareFamilies: string = null;
  @Input() upsellLoading: boolean;
  @Input() upsellSelected: boolean = false;
  @Input() noShadow: boolean = false;
  @Input() isMobile: boolean;
  @Input() showUpsell: boolean = false;
  @Input() isFlightBySector: boolean = false;
  
  @Output() openUpsell: EventEmitter<void> = new EventEmitter();

  constructor() { }

  public loaderColor: string = loaderColors.GRAY;
  public loaderSize: BtnLoaderSize = BtnLoaderSize.XS;

  get baggageImproveMessage(): string {
    return !this.baggage ? 'IMPROVE_YOUR_FLIGHT_NOT_BAGGAGE' : 'IMPROVE_YOUR_FLIGHT_WITH_BAGGAGE';
  }
  
  get agentTravelImage(): string {
    return agentTravelImage;
  }

  get bannerUpsellSelectedMobile(): boolean {
    return this.upsellSelected && this.isMobile;
  }

  get bannerUpsellSelectedDesktop(): boolean {
    return this.upsellSelected && !this.isMobile;
  }

  get cleanFareFamilyNames(): string {
    if (isNullOrUndefined(this.fareFamilies)) {
      return '';
    }
    return this.fareFamilies.replace(FARE_PATTERNS, '')?.trim();
  }

}
